import ModuleLoaderService, { ModuleType, type ModuleGroupsLoadingConfig } from '@ts/services/module-loader-service';
import InitializerService from '@ts/services/initializers-service';
import { Global } from '@ts/globals.d';

const loadDefaultJSModules = async () => {
    const SERVICE_MODULES: ModuleGroupsLoadingConfig = {
        moduleType: ModuleType.SERVICE,
        moduleGroups: [
            [
                'alpine-init-service',
                'back-to-top-button-init-service',
                'back-to-last-site-button-init-service',
                'login-statusbar-init-service',
                'session-timeout-init-service',
                'form-errors',
                'form-errors-a11y',
            ],
        ],
    };

    await ModuleLoaderService.loadJSModules(SERVICE_MODULES);
};

const loadOptionalJSModules = async () => {
    const OPTIONAL_SERVICE_MODULES: ModuleGroupsLoadingConfig = {
        moduleType: ModuleType.SERVICE,
        moduleGroups: [[]],
    };
    const OPTIONAL_COMPONENT_MODULES: ModuleGroupsLoadingConfig = {
        moduleType: ModuleType.COMPONENT,
        moduleGroups: [[]],
    };

    if (document.querySelectorAll(Global.FormControlsWithValueStateSelector).length > 0) {
        OPTIONAL_SERVICE_MODULES.moduleGroups.push(['form-controls-with-value-state-service']);
    }

    if (OPTIONAL_SERVICE_MODULES.moduleGroups.length > 0) {
        await ModuleLoaderService.loadJSModules(OPTIONAL_SERVICE_MODULES);
    }
    if (OPTIONAL_COMPONENT_MODULES.moduleGroups.length > 0) {
        await ModuleLoaderService.loadJSModules(OPTIONAL_COMPONENT_MODULES);
    }
};

const handleAllInitializersFinished = () => {
    Alpine && Alpine.start();
};

const main = async () => {
    await loadDefaultJSModules();
    await loadOptionalJSModules();

    InitializerService.checkInitializers(handleAllInitializersFinished);
};

main();

// Accept HMR as per: https://vitejs.dev/guide/api-hmr.html
// @ts-ignore
if (import.meta.hot) {
    // @ts-ignore
    import.meta.hot.accept(() => {});
}
